export default {
  number: /^(([^0][0-9]+|0)$)|^(([1-9]+)$)/, // 整数
  numberZero: /^([1-9]\d*|[0]{1,1})$/,
  integer: /^[1-9]\d*$/, // 正整数
  decimal: /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^(([^0][0-9]+|0)$)|^(([1-9]+)\.([0-9]{1,2})$)|^(([1-9]+)$)|^(([1-9]+)\.$)/,
  decimalOne: /^(0|([1-9]\d{0,1})|100|([0-9]\d{0,1})\.([0-9]{1}))$/, // 0 - 100 可以含1位小数的正数
  decimalAge: /^(0|([1-9]\d{0,1})|100|([0-9]\d{0,1})\.5)$/, // 0 - 100 可以含.5的正数
  positiveDecimal: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/, // 正数（包含小数）
  pinyin: /^([A-Z][a-z]*|[a-z]+|[\u4E00-\u9FA5]+|\d+)$/g,
  chinese: /^[\u4E00-\u9FA5]/,
  percent: /^(0|([1-9]\d{0,1})|100)$/, // 0-100整数
  captcha: /^[0-9A-Za-z]{4}$/,
  code: /^[0-9]{4}$/,
  smsCode: /^[0-9]{6}$/,
  mobile: /^1[3456789]\d{9}$/,
  phone: /^1[3-9]\d{9}$/,
  email: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
  idCard: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  noEmpty: /\S+/,
  user: /^[a-z0-9A-Z]+$/,
  pwd: /^[a-zA-Z0-9_-]{6,20}$/,
  // 台胞证正则表达式
  TAIWAN_ID_CARD_REGEX: /^[a-zA-Z][0-9]{9}$/,
  // 护照正则表达式
  PASSPORT_REGEX: /^([a-zA-z]|[0-9]){5,17}$/,
  // 港澳通行证正则表达式
  HK_MACAO_PASS_REGEX: /^([A-Z]\d{6,10}(\w1)?)$/,
  IS_IMAGE: /\w+\.(jpg|gif|bmp|png)/,
  newPwd: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]|.*[.@$!%*#_~?&^])[0-9A-Za-z.@$!%*#_~?&^]{8,20}$/
};
